<template>
  <span class="d-flex align-items-start">
    <div class="d-lg-none col-5">
      <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
    </div>
    <div class="col-7 col-lg-12 font-size d-flex align-items-center">
      <span
        :key="row[column.index]"
        v-tooltip="{
          textWrap: true,
          hide: tooltipHide,
          title: tooltipTitle,
        }"
        :class="column.name === 'e-mail' ? 'd-block sortable__cell__text' : 'w-100'"
      >
        <template v-if="type === 'admin-logs' && getEditUrl(row, column.name)">
          <a :href="editUrl" target="_blank" class="list__link">
            {{ row[column.index ? column.index : column.name] }}
          </a>
        </template>
        <span v-else class="list__cell">
          <router-link
            v-if="type === 'training' && index === 1"
            :to="{ name: 'TrainingDashboard', params: { trainingId: row[idKey] } }"
          >
            {{ sanitizeData }}
          </router-link>
          <span v-else>{{ sanitizeData }}</span>
        </span>
      </span>
      <span
        v-if="
          type === 'institution' &&
          column.index === '0' &&
          row[row.length - 1] !== null &&
          typeof row[row.length - 1] === 'string'
        "
        v-tooltip="{
          title: $t('admin.user.last_connection') + formatDate(row[row.length - 1]),
        }"
        class="pellet"
      ></span>
    </div>
  </span>
</template>

<script>
import SortTableMobileFirstColumnComponent from "@/components/table/sortTable/SortTableMobileFirstColumnComponent.vue";
import { dateFormatter } from "@/services/utilities/date-formatter";

export default {
  name: "SortTableBasicDataCellComponent",
  components: { SortTableMobileFirstColumnComponent },
  props: {
    column: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    nbColumns: {
      type: Number,
      required: true,
    },
    idKey: {
      type: Number,
      default: 0,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
    dateFormat: {
      type: String,
      required: true,
    },
  },
  emits: [],
  data() {
    return {
      editUrl: "",
    };
  },
  computed: {
    cellData() {
      return this.displayCellData(this.row, this.column);
    },
    sanitizeData() {
      const tmp = document.createElement("div");
      tmp.innerHTML = this.cellData;
      return tmp.textContent || tmp.innerText || "";
    },
    tooltipHide() {
      const condition1 = this.column.name !== "email" && String(this.cellData).length < 25;
      const condition2 = this.type === "training" && this.index === 1;
      return !condition1 && !condition2;
    },
    tooltipTitle() {
      const condition1 = this.column.name !== "email" && String(this.cellData).length > 25;
      const condition2 = this.type === "training" && this.index === 1;
      if (condition1 && condition2) {
        return `${this.sanitizeData}\n${this.$t("registration.dashboard.go_to")}`;
      }
      if (condition1) return this.sanitizeData;
      if (condition2) return this.$t("registration.dashboard.go_to");
      return "";
    },
  },
  methods: {
    displayCellData(row, column) {
      const columnKey = column.index || column.name;
      const cellValue = row[columnKey];

      const iso8601Regex = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-][0-2]\d:[0-5]\d)?/;
      const isDate = iso8601Regex.test(cellValue);

      if (isDate) {
        return this.formatDate(cellValue);
      }

      return cellValue || "--";
    },

    getEditUrl(row, columnName) {
      this.editUrl = null;
      const editUrl = row[7];

      if (
        editUrl &&
        typeof editUrl === "string" &&
        (editUrl.startsWith("/admin/") || editUrl.startsWith("/studea-manager/")) &&
        (columnName === "objectId" || columnName === "Id")
      ) {
        this.editUrl = editUrl;
        return true;
      }

      return false;
    },

    formatDate(date) {
      return dateFormatter.format(date, this.dateFormat);
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  &__cell {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @include up-to-md {
      -webkit-line-clamp: none;
      overflow: visible;
      text-overflow: unset;
    }
  }
}
</style>
